import { lockBody, unlockBody } from './functions'

const body = document.body

const setThemeVars = () => {
  const documentWidth = document.documentElement.clientWidth
  const width = Math.abs(window.innerWidth - documentWidth)
  body.style.setProperty('--scrollbar-width', `${width}px`)

  const mainContainer = document.querySelector('footer')
  const mainContainerWidth = mainContainer.clientWidth

  const col = document.querySelector('.vn-col-sizer')
  const colWidth = col.clientWidth

  const headerContainer = document.querySelector('header')
  if (headerContainer) {
    const headerContainerHeight = headerContainer.clientHeight
    body.style.setProperty('--header-height', `${headerContainerHeight}px`)
  }

  body.style.setProperty(
    '--space-width',
    `${(documentWidth - mainContainerWidth) / 2 + 20}px`
  )

  body.style.setProperty('--container-width', `${mainContainerWidth}px`)
  body.style.setProperty('--main-width', `${documentWidth}px`)
  body.style.setProperty('--col-width', `${colWidth}px`)
}

setThemeVars()
window.addEventListener('load', setThemeVars)
window.addEventListener('resize', setThemeVars)

document.addEventListener('DOMContentLoaded', (e) => {
  const jsLoader = e.target.querySelector('.js-loader')
  if (jsLoader) {
    const loaderIsHidden = JSON.parse(
      sessionStorage.getItem('loader-is-hidden') ?? false
    )
    if (!loaderIsHidden) {
      document.body.classList.add('is-hidden')
      jsLoader.classList.add('active')
      lockBody()
      setTimeout(() => {
        document.body.classList.remove('is-hidden')
        jsLoader.classList.remove('active')
        unlockBody()
      }, 1500)
      sessionStorage.setItem('loader-is-hidden', 'true')
    } else {
      document.body.classList.remove('is-hidden')
    }
  } else {
    document.body.classList.remove('is-hidden')
  }

  const blocks = document.querySelectorAll('.vn-block')

  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -50px 0px',
    threshold: 0.2,
  }

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible')
        if (entry.target.classList.contains('text-value__block')) {
          const values = entry.target.querySelectorAll('.item__title')
          values.forEach((value) => {
            const target = parseInt(value.dataset.target)
            const percent = value.querySelector('span')
            let percentInterval = setInterval(() => {
              percent.innerText =
                parseInt(percent.innerText) + parseInt((target / 20).toFixed(0))
              if (percent.innerText >= target) {
                clearInterval(percentInterval)
                percent.innerText = target
              }
            }, 50)
          })
        }
        observer.unobserve(entry.target)
      }
    })
  }, observerOptions)

  if (blocks.length) {
    blocks.forEach((block) => {
      observer.observe(block)
    })
  }
})
